import { createFileRoute } from '@tanstack/react-router';
import { redirectToSegmentDefaultTab } from '@/pages/workspaces/activity-logs/routing';

// Index → default tab. Segment canonicalization happens in the tab view.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/profile_activity/')({
  beforeLoad: ({ params }) => redirectToSegmentDefaultTab('profile_activity', params),
});
